import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

import { Text } from "@ui5/webcomponents-react/lib/Text";
import { List } from "@ui5/webcomponents-react/lib/List";
import { StandardListItem } from "@ui5/webcomponents-react/lib/StandardListItem";
import { PageBackgroundDesign } from "@ui5/webcomponents-react/lib/PageBackgroundDesign";
import { Page } from "@ui5/webcomponents-react/lib/Page";
import { Button } from "@ui5/webcomponents-react/lib/Button";
import { ButtonDesign } from "@ui5/webcomponents-react/lib/ButtonDesign";
import MessageStripCompnt from "../../shared/components/UIElements/MessageStrip";
import { Title } from "@ui5/webcomponents-react/lib/Title";
import { TitleLevel } from "@ui5/webcomponents-react/lib/TitleLevel";

import axios from "axios";
import "./RecommendationsList.css";

const RecommendationsList = (props) => {
  const [paymentRunsToApprove, setPaymentRunsToApprove] = useState([]);
  const [paymentRunsApproved, setPaymentRunsApproved] = useState([]);
  const [errorPending, setErrorPending] = useState("");
  const [errorApproved, setErrorApproved] = useState("");
  const [showPreviousApprovals, setShowPreviousApprovals] = useState(false);

  const getPendingPayruns = async () => {
    setErrorPending(null);
    await axios
      .get(`api/payruns/pending/` + props.user, {
        headers: { Authorization: props.token },
      })
      .then(function (response) {
        setPaymentRunsToApprove(response.data.rows);
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            setErrorPending(error.response.data.message);
            props.handleLogout();
          } else {
            setErrorPending(error.response.data.message);
          }
        } else {
          setErrorPending(
            "Something went wrong. Please verify your Internet connection."
          );
        }
      });
  };

  const getApprovedPayruns = async () => {
    setErrorApproved(null);
    await axios
      .get(`api/payruns/approved/` + props.user, {
        headers: { Authorization: props.token },
      })
      .then(function (response) {
        setPaymentRunsApproved(response.data.rows);
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            setErrorApproved(error.response.data.message);
            props.handleLogout();
          } else {
            setErrorApproved(error.response.data.message);
          }
        } else {
          setErrorApproved(
            "Something went wrong. Please verify your Internet connection."
          );
        }
      });
  };

  const navBackButtonHandler = () => {
    props.history.goBack();
  };

  useEffect(() => {
    getPendingPayruns();
    getApprovedPayruns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const previousApprovals = {
    show(cb) {
      setShowPreviousApprovals(true);
    },
    hide(cb) {
      setShowPreviousApprovals(false);
    },
  };

  const payrunClickHandler = (payrun) => {
    props.history.push(`/approvals/${payrun.Id}`);
  };

  return (
    <Page
      title={props.title}
      showFooter={false}
      showHeader={true}
      showBackButton={true}
      backgroundDesign={PageBackgroundDesign.Transparent}
      onNavButtonPress={navBackButtonHandler}
    >
      <div className="container">
        <Title level={TitleLevel.H2} wrap={false}>
          <br />
          <b>{props.company.split("(")[0]}</b>
          <br />
          {props.company.split("(")[1].slice(0, -1)}
          <br />
        </Title>
        <Title className="title" level={TitleLevel.H5} wrap={false}>
          <br />
          Pending Approvals
        </Title>
        {paymentRunsToApprove.map((payrun) => (
          <List
            onItemClick={() => {
              payrunClickHandler(payrun);
            }}
            key={payrun.Id}
          >
            <StandardListItem className="list_item">
              <Text>{payrun.WizardName}</Text>
              <br />
              <Text className="extra__info">{payrun.PmntDate}</Text>
              <br />
              <Text className="extra__info">{payrun.CompanyName}</Text>
            </StandardListItem>
          </List>
        ))}
        {errorPending && (
          <MessageStripCompnt
            className="message_strip"
            type="info"
            message={errorPending}
          />
        )}
        <Title className="thick" level={TitleLevel.H5} wrap={false}>
          <br />
          Previous Approvals
          <br />
        </Title>
        {showPreviousApprovals ? (
          <div>
            <Button
              className="button_hide_show"
              design={ButtonDesign.Emphasized}
              onClick={previousApprovals.hide}
            >
              Hide
            </Button>
            {paymentRunsApproved.map((payrun) => (
              <List
                key={payrun.Id}
                onItemClick={() => {
                  payrunClickHandler(payrun);
                }}
              >
                <StandardListItem className="list_item">
                  <Text>{payrun.WizardName}</Text>
                  <br />
                  <Text className="extra__info">{payrun.PmntDate}</Text>
                  <br />
                  <Text className="extra__info">{payrun.CompanyName}</Text>
                </StandardListItem>
              </List>
            ))}
            <br />
            {errorApproved && (
              <MessageStripCompnt
                className="message_strip"
                type="info"
                message={errorApproved}
              />
            )}
          </div>
        ) : (
          <Button
            className="button_hide_show"
            design={ButtonDesign.Emphasized}
            onClick={previousApprovals.show}
          >
            Show
          </Button>
        )}
      </div>
    </Page>
  );
};

export default withRouter(RecommendationsList);
